import React, { useState } from "react";
import { createCouponService } from "../../../services/apiService";

/* ✅ single source of truth */
const initialFormState = {
  couponid: "",
  coupondesc: "",
  amount: "",
  notimes: "",
  validfrom: "",
  validto: "",
  minordervalue: "",
  disp: "",
  type: "",
  maxdisvalue: "",
  disc1: "",
  disc2: "",
  disc3: "",
  disc4: "",
  active: 1,
  created_by: 4,
};

const CouponCreation = () => {
  const [formData, setFormData] = useState(initialFormState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createCouponService(formData);
      alert("Coupon created successfully ✅");
      setFormData(initialFormState);
    } catch (err) {
      console.error(err);
      alert("Failed to create coupon ❌");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h3 style={{ textAlign: "center", color: "green" }}>Coupon Creation</h3>

      <form onSubmit={handleSubmit} className="coupon-form">
        {/* Row 1 */}
        <div className="row">
          <div className="field">
            <label>Coupon Id</label>
            <input
              name="couponid"
              value={formData.couponid}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Amount</label>
            <input
              name="amount"
              value={formData.amount}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>No of Times</label>
            <input
              name="notimes"
              value={formData.notimes}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Min Order</label>
            <input
              name="minordervalue"
              value={formData.minordervalue}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="row">
          <div className="field">
            <label>Discount %</label>
            <input name="disp" value={formData.disp} onChange={handleChange} />
          </div>

          <div className="field">
            <label>Valid From</label>
            <input
              type="date"
              name="validfrom"
              value={formData.validfrom}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Valid To</label>
            <input
              type="date"
              name="validto"
              value={formData.validto}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Max Discount</label>
            <input
              name="maxdisvalue"
              value={formData.maxdisvalue}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Row 3 */}
        <div className="row">
          <div className="field">
            <label>Type</label>

            <select name="type" value={formData.type} onChange={handleChange}>
              <option value="">Select Type</option>
              <option value="Banner">Banner</option>
              <option value="Normal">Dealer</option>
            </select>
          </div>

          <div className="field">
            <label>Active</label>
            <select
              name="active"
              value={formData.active}
              onChange={handleChange}
            >
              <option value={1}>Active</option>
              <option value={0}>Inactive</option>
            </select>
          </div>

          <div className="field span-2">
            <label>Description</label>
            <textarea
              name="coupondesc"
              rows="2"
              value={formData.coupondesc}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Row 4 */}
        <div className="row">
          <div className="field">
            <label>Description-1</label>
            <input
              name="disc1"
              value={formData.disc1}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Description-2</label>
            <input
              name="disc2"
              value={formData.disc2}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Description-3</label>
            <input
              name="disc3"
              value={formData.disc3}
              onChange={handleChange}
            />
          </div>

          <div className="field">
            <label>Description-4</label>
            <input
              name="disc4"
              value={formData.disc4}
              onChange={handleChange}
            />
          </div>
        </div>

        <button type="submit" className="submit-btn">
          Submit
        </button>
      </form>
      {/* Styles */}
      <style>{`
      .coupon-form .row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.coupon-form .field {
  flex: 1;   /* 🔥 forces 4 equal columns */
}

.coupon-form .span-2 {
  flex: 2;   /* description takes 2 columns */
}

        .coupon-form label {
          display: block;
          font-size: 13px;
          margin-bottom: 4px;
          border-radius:18px;
          color: #4b4d4e ;
        }

        .coupon-form input,
        .coupon-form select,
        .coupon-form textarea {
          width: 100%;
          padding: 8px;
          border: 1px solid #d1d5db;
          border-radius: 4px;
          font-size: 13px;
               color: #4b4d4e ;
        }

        .submit-btn {
          background: #005487;
          color: white;
          padding: 8px 18px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }

        .submit-btn:hover {
          background: #166534;
        }
      `}</style>
    </div>
  );
};

export default CouponCreation;
